export const metricType = {
    COUNT: "count",
    TIME: "time"
};

export const ledControllerColorOrder = {
    RGB: "RGB",
    BRG: "BRG",
    BGR: "BGR",
    GBR: "GBR",
    RBG: "RBG"
};



// WEBPACK FOOTER //
// ./src/components/util/enums.js